import React, { createRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import handleViewport from 'react-in-viewport';
import isTouch from 'is-touch';
import VideoCursor from '../parts/VideoCursor';

const Video =  handleViewport(({video, image, forwardedRef, inViewport, ...props}) => {
  const videoRef = createRef();
  const [ hovered, setHovered ] = useState(false);
  const [ videoReady, setVideoReady ] = useState(false);
  const [ buttonLabel, setButtonLabel ] = useState('Play');
  const [ muteButtonLabel, setMuteButtonLabel ] = useState('Mute');

  useEffect(() => {
    if(inViewport && videoRef.current.paused){
      _handlePlay();
    }
    if(!inViewport && !videoRef.current.paused){
      _handlePause();
    }
  }, [inViewport]);

  const _handleOnCanPlay = e => {
    setVideoReady(true);
  }

  const _handlePlay = e => {
    videoRef.current.play();
    videoRef.current.muted = false;
    setButtonLabel('Pause');
    setMuteButtonLabel('Mute');
  }

  const _handlePause = e => {
    videoRef.current.pause();
    setButtonLabel('Play');
  }

  const _handlePlayPauseClick = e => {
    if(videoRef.current.paused){
      _handlePlay();
    }else{
      _handlePause();
    }
  }

  const _handleMute = () => {
    videoRef.current.muted = !videoRef.current.muted;

    if(videoRef.current.muted){
      setMuteButtonLabel('Unmute');
    }else{
      setMuteButtonLabel('Mute');
    }
  }

  const _handleMouseEnter = e => setHovered(true);
  const _handleMouseLeave = e => setHovered(false);

  return (
    <div className={classNames('module module--video', {
      'module--visible': inViewport
    })}>
      <div className="inner">
        {video &&
          <div className={classNames('video', {
              'hovered': hovered,
              'visible': inViewport
            })} ref={forwardedRef}>
            <video
              ref={videoRef}
              type={`${video.type}/${video.subtype}`}
              src={video.url}
              playsInline
              poster={image.url || null}
              muted
              onMouseEnter={e => _handleMouseEnter(e)}
              onMouseLeave={e => _handleMouseLeave(e)}
              onClick={e => _handlePlayPauseClick(e)}
              onCanPlay={e => _handleOnCanPlay(e)}
            />
            {videoReady &&
              <div className="mobile-controls">
                <div onClick={() => _handleMute()}>
                  {muteButtonLabel}
                </div>
                <div onClick={e => _handlePlayPauseClick(e)}>
                  {buttonLabel}
                </div>
              </div>
            }
            {!isTouch &&
              <VideoCursor>{buttonLabel}</VideoCursor>
            }
          </div>
        }
        <div className="video__footer">
          {props.description &&
            <div className="description">
            {props.description}
            </div>
          }
          {videoReady &&
            <div className="mute-video" onClick={() => _handleMute()}>
              {muteButtonLabel}
            </div>
          }
        </div>
      </div>
    </div>
  )
});

export default Video;
